import DashboardCard from '/@/components/bayer/dashboard-card';
import { useGrowersDashboard } from '/@/hooks/dashboards';
import { _ } from '/@/locale';
import { getNodeScopeFilters } from '/@/utils/node-scope';

const GrowersDashboardCard = () => {
    const growersDashboardQuery = useGrowersDashboard({
        ...getNodeScopeFilters('rvs'),
    });

    return (
        <DashboardCard
            title={_('Productores')}
            subtitle={`${growersDashboardQuery.data?.withFieldview || 0} ${_('conectados con Fieldview')}`}
            isLoading={growersDashboardQuery.isLoading}
            number={growersDashboardQuery.data?.count}
        />
    );
};

export default GrowersDashboardCard;
